import { render, staticRenderFns } from "./BillSingle.vue?vue&type=template&id=d0c25bdc&scoped=true&"
import script from "./BillSingle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BillSingle.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BillSingle.vue?vue&type=style&index=0&id=d0c25bdc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c25bdc",
  null
  
)

export default component.exports